const Style = {
    container: "block lg:flex justify-center w-full gap-8"
}

export default Style